import { IAppEntity } from "src/config/entities";
import React from "react";
import { ReferenceTypes } from "src/enums/ReferenceTypes";
import { PurchaseOrdersService } from "src/services/documents/PurchaseOrdersService";
import { DocumentPostStatusEnum } from "src/enums/DocumentPostStatusEnum";
import { PostingOfGoodsDetail } from "src/components/Pages/Documents/Warehouse/PostingOfGoods/components/PostingOfGoodsDetail";
import PostingOfGoodsList from "src/components/Pages/Documents/Warehouse/PostingOfGoods/components/PostingOfGoodsList";
import { NFLookupPostingOfGoods } from "src/components/Shared/NewForms/NFLookupPostingOfGoods";
import { PostingOfGoodsDto } from "src/components/Pages/Documents/Warehouse/PostingOfGoods/dtos/PostingOfGoodsDto";
import { PostingOfGoodsService } from "src/services/documents/PostingOfGoodsService";

export const PostingOfGoods: IAppEntity = {
  entityType: "document",
  title: "Posting Of Goods",
  pluralTitle: "Posting Of Goods",
  apiUrl: "PostingOfGoods",
  apiEnum: ReferenceTypes.DocumentPostingOfGood,
  getDetailView: (id?: string) => {
    return React.createElement(PostingOfGoodsDetail, {
      id: id
    });
  },
  getDetailViewComponent: (model: any, modelUpdatedEvent: (model: any) => void) => React.createElement(React.Fragment, {}),
  getListView: (model: any, modelUpdatedEvent: (model: any) => void) =>
    React.createElement(PostingOfGoodsList, {
      model: model,
      modelUpdatedEvent: modelUpdatedEvent
    }),

  getLookupComponent(model: any): any {
    return React.createElement(NFLookupPostingOfGoods, {
      fieldName: model.fieldName,
      title: model.title,
      setSelectedCatalog: model.setSelectedCatalog
    });
  },
  getDataService: () => new PostingOfGoodsService("PostingOfGoods"),
  getEmptyModel: () => {
    const model: PostingOfGoodsDto = {
      totalAmount: 0,
      totalAmountVat: 0,
      status: DocumentPostStatusEnum.Draft,
      documentDate: new Date(),
      createdDate: new Date(),
      products: []
    };
    return model;
  }
};
